import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyChanges: {
        id: 'endorsement.bop.view.Policy Changes',
        defaultMessage: 'Policy Changes'
    },
    PolicyChangeEfectiveDate: {
        id: 'endorsement.bop.views.payment.Policy Change Effective Date',
        defaultMessage: 'Policy Change Effective Date'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.bop.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    SelectTypeOfChanges: {
        id: 'endorsement.bop.view.Select Type of Changes',
        defaultMessage: 'Select Type of Changes'
    },
    RenewalEffectiveDateMsgDesc: {
        id: 'endorsement.bop.view.Please confirm the policy change are for Renewal policy',
        defaultMessage: 'Please confirm the policy change are for Renewal policy'
    },
    RenewalEffectiveDateMsg: {
        id: 'endorsement.bop.view.Review Effective Date Changes',
        defaultMessage: 'Review Effective Date Changes'
    }
});
